import React from 'react';
import { CommandDispatcher } from '../../concepts/commands/CommandDispatcher';
import { Colors } from '../../ui';
import { UseLocationScope } from '../AppLocation';
import { useResolve } from '../Container';
import { AccountHeaderBlock } from '../account/AccountHeaderBlock';
import { AccountPage } from '../account/AccountPage';
import { PageLoader } from '../account/PageLoader';
import { PlanStateHeaderBlock } from '../account/PlanStateHeaderBlock';
import { Scroller } from '../boards/Scroller';
import { Page } from '../common/Page';
import { UseReturnLocation } from '../common/ReturnLocation';
import { Flexer } from '../dashboard/elements/LayoutElements';
import { QuickMenuStrip } from '../workspace/QuickMenuStrip';
import { workspaceImportLegacy } from '../workspace/WorkspaceCommands';
import { LegacyBoardsScope } from './LegacyBoardsScope';
import { LegacyBoardsView } from './LegacyBoardsView';

const LegacyBoardsMenuStrip = () => {

    const dispatch = useResolve(CommandDispatcher);
    const onImportAll = () => void (dispatch(workspaceImportLegacy));

    return <QuickMenuStrip>
        <QuickMenuStrip.Button
            data-tour="ab-template"
            label="Batch Import"
            icon="deqo://icons/dash/add-board"
            color={Colors.observe}
            onClick={onImportAll}
        />
    </QuickMenuStrip>;
};

export const LegacyBoardsPage = () =>
    <AccountPage>
        <LegacyBoardsScope loader={PageLoader}>
            <UseReturnLocation href="/legacy" />
            <UseLocationScope name="legacy" value="legacy" label="Legacy Boards" />
            <Page.Header>
                <Page.Title>Legacy Boards</Page.Title>
                <Page.HeaderPush>
                    <PlanStateHeaderBlock />
                    <AccountHeaderBlock />
                </Page.HeaderPush>
            </Page.Header>
            <Scroller>
                <Flexer grow flex="column" style={{ background: Colors.hover, minHeight: '100%' }}>
                    <LegacyBoardsMenuStrip />
                    <Flexer grow flex="column">
                        <Page.Content>
                            <LegacyBoardsView />
                        </Page.Content>
                    </Flexer>
                </Flexer>
            </Scroller>
        </LegacyBoardsScope>
    </AccountPage>;
